/**  teacher actions constants */
export const SET_LIST_TEACHER = 'teacher/SET_LIST_TEACHER';